import { AppColors } from "@/styles/colors";
import { Field, Textarea } from "@chakra-ui/react";
import { KeyboardEvent } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

interface Props {
  register: UseFormRegister<FieldValues>;
  errors: any;
  placeholder?: string;
  inputName: string;
  labelText?: string;
  helperText?: string;
  maxLength?: number;
  resize?: string;
  allowedPattern?: RegExp;
  required?: boolean;
  variant?: "outline" | "subtle" | "flushed";
  disabled?: boolean;
}

export const TextArea = ({
  register,
  errors,
  placeholder,
  inputName,
  labelText,
  helperText,
  maxLength,
  resize,
  allowedPattern,
  required,
  disabled,
  variant = "outline",
}: Props) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (allowedPattern) {
      const key = e.key;
      if (!allowedPattern.test(key) && key.length === 1) {
        e.preventDefault();
      }
    }
  };

  return (
    <Field.Root invalid={!!errors[inputName]} required={required}>
      {labelText && (
        <Field.Label>
          {labelText} <Field.RequiredIndicator />
        </Field.Label>
      )}
      <Textarea
        maxLength={maxLength}
        placeholder={placeholder}
        {...register(inputName)}
        minHeight="116px"
        borderRadius="8px"
        size="xl"
        resize={resize ?? "none"}
        paddingX="20px"
        paddingY="10px"
        onKeyDown={handleKeyDown}
        variant={variant}
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        disabled={disabled}
        data-testid="text-area-input"
      />
      {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
      <Field.ErrorText>{errors?.[inputName]?.message}</Field.ErrorText>
    </Field.Root>
  );
};
